import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useCallback } from 'react';
import * as Sentry from '@sentry/nextjs';
import { DataSource } from '../hooks/useDataSourceSelect';
import logger from '@/utils/logger';
import { useToast } from '@/hooks/useToast';
import { Loader } from '@/components/loaders/Modal';
import Header from '../../Header';
import UploadFile from './UploadFile';
import WorkbooksSelect from './WorkbooksSelect';
import Footer from './Footer';
import DataSourcesDrawer from './DataSourcesDrawer';
import headerStyles from '@/components/Editor/modals/Header/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7073 6.29289C16.0978 6.68342 16.0978 7.31658 15.7073 7.70711L11.4144 12L15.7073 16.2929C16.0978 16.6834 16.0978 17.3166 15.7073 17.7071C15.3167 18.0976 14.6836 18.0976 14.293 17.7071L8.58594 12L14.293 6.29289C14.6836 5.90237 15.3167 5.90237 15.7073 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowLeft.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CloseIcon = function CloseIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M17.1548 0.488155C17.8057 -0.162718 18.861 -0.162718 19.5118 0.488155C20.1627 1.13903 20.1627 2.1943 19.5118 2.84518L12.357 10L19.5118 17.1548C20.1627 17.8057 20.1627 18.861 19.5118 19.5118C18.861 20.1627 17.8057 20.1627 17.1548 19.5118L10 12.357L2.84518 19.5118C2.1943 20.1627 1.13903 20.1627 0.488156 19.5118C-0.162719 18.861 -0.162719 17.8057 0.488156 17.1548L7.64298 10L0.488156 2.84518C-0.162718 2.1943 -0.162718 1.13903 0.488156 0.488155C1.13903 -0.162718 2.19431 -0.162718 2.84518 0.488155L10 7.64298L17.1548 0.488155Z",
      fill: "#BABDCC"
    })
  }));
};

CloseIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const PREFIX = 'components: Editor: modals: Data: AddNew:';
export const CloseButton = _ref => {
  let {
    className = '',
    onClick
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    className: clsx(headerStyles.close, className),
    type: "button",
    onClick: onClick,
    children: /*#__PURE__*/_jsx(CloseIcon, {})
  });
};

const DataAddNewData = _ref2 => {
  let {
    user,
    workbookId,
    dataSource = DataSource.LOCAL_FILE,
    dataSourceOptions,
    isDisabled = false,
    isLoading = false,
    containerWidth = 0,
    onClose = () => null,
    onChange = () => null,
    onChangeDataSource = () => null,
    onChangeWorkbook = () => null,
    getGoogleDriveFile
  } = _ref2;
  const {
    addToast: sendNotification
  } = useToast(); // Notify user of catostrophic render error

  const handleUploadError = useCallback(userErr => {
    logger.error(`${PREFIX} handleUploadError: ${userErr}`);
    sendNotification({
      type: 'error',
      description: userErr.userMessage || 'Unexpected error during render'
    });
    Sentry.captureException(Error(`${PREFIX}: failed to render ${userErr}`));
  }, [sendNotification]);
  const handleWorkbookChange = useCallback(workbook => {
    // make sure the workbook is not the same as the current one
    if (!workbook || workbook.id === workbookId) return;
    onChangeWorkbook(workbook);
  }, [onChangeWorkbook, workbookId]);
  const isTabletOrDesktop = containerWidth > 800;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      heading: "Add Data",
      headingIcon: /*#__PURE__*/_jsx(ArrowLeft, {
        className: styles.headerIcon,
        width: 24,
        height: 24,
        onClick: onClose
      }),
      headingTooltip: "Provide data to this widget by uploading a supported file, selecting existing data, or connecting a file from Google Drive",
      customCloseButton: /*#__PURE__*/_jsx(CloseButton, {
        className: containerWidth < 400 ? '-d-none' : '',
        onClick: onClose
      })
    }), isLoading ? /*#__PURE__*/_jsx(Loader, {
      className: styles.loader,
      title: ""
    }) : /*#__PURE__*/_jsxs("div", {
      className: styles.main,
      children: [isTabletOrDesktop ? /*#__PURE__*/_jsx("div", {
        className: styles.article,
        children: dataSource === DataSource.TEAM_WORKBOOKS ? /*#__PURE__*/_jsx(WorkbooksSelect, {
          workbookId: workbookId,
          teamId: (user === null || user === void 0 ? void 0 : user.teamId) || '',
          onSelect: handleWorkbookChange
        }) : /*#__PURE__*/_jsx(UploadFile, {
          isDisabled: isDisabled,
          onError: handleUploadError,
          onChange: onChange
        })
      }) : null, /*#__PURE__*/_jsx("div", {
        className: styles.aside,
        children: /*#__PURE__*/_jsx(DataSourcesDrawer, {
          dataSource: dataSource,
          getGoogleDriveFile: getGoogleDriveFile,
          dataSourceOptions: dataSourceOptions,
          onChange: onChange,
          onChangeDataSource: onChangeDataSource,
          isSmallContainer: !isTabletOrDesktop
        })
      })]
    }), !isTabletOrDesktop && /*#__PURE__*/_jsx(Footer, {
      dataSource: dataSource,
      teamId: (user === null || user === void 0 ? void 0 : user.teamId) || '',
      workbookId: workbookId,
      isDisabled: isDisabled,
      onChange: onChange,
      onChangeWorkbook: handleWorkbookChange
    })]
  });
};

export default DataAddNewData;